import React, { useState, useEffect } from "react"

const defaultState = { defaultValue: "INR" }
const CurrencyContext = React.createContext(defaultState)
const isBrowser = () => typeof window !== "undefined"

const languageCurrencyMap = {
  "en-in": "INR",
  "en-us": "USD",
  "en-uk": "GBP",
}

const getInitialCurrency = () => {
  if (isBrowser()) {
    const path = window.location.pathname
    const segments = path.split("/").filter(Boolean)
    const langKey = segments.length > 0 ? segments[0].toLowerCase() : "en-in"
    return languageCurrencyMap[langKey] || "INR"
  }
  return "INR"
}

const ThemeContext = ({ children }) => {
  const [activeState, setActiveState] = useState(() => {
    if (isBrowser() && window.localStorage.getItem("activeState")) {
      const storedState = JSON.parse(window.localStorage.getItem("activeState"))
      const urlCurrency = getInitialCurrency()
      return storedState.defaultValue !== urlCurrency
        ? { defaultValue: urlCurrency }
        : storedState
    }
    return { defaultValue: getInitialCurrency() }
  })

  useEffect(() => {
    window.localStorage.setItem("activeState", JSON.stringify(activeState))
  }, [activeState])

  const handleUrlChange = () => {
    setTimeout(() => {
      const newCurrency = getInitialCurrency()
      setActiveState(prev =>
        prev.defaultValue !== newCurrency ? { defaultValue: newCurrency } : prev
      )
    }, 0)
  }

  useEffect(() => {
    window.addEventListener("popstate", handleUrlChange)
    
    const originalPushState = window.history.pushState
    window.history.pushState = function (...args) {
      originalPushState.apply(window.history, args)
      handleUrlChange()
    }

    return () => {
      window.removeEventListener("popstate", handleUrlChange)
      window.history.pushState = originalPushState // Restore original method.
    }
  }, [])

  return (
    <CurrencyContext.Provider
      value={{
        defaultValue: activeState.defaultValue,
        chooseMe: (e) => setActiveState({ defaultValue: e.value }),
      }}
    >
      {children}
    </CurrencyContext.Provider>
  )
}

export default CurrencyContext
export { ThemeContext }